import { Menu } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext.js'
import { useSidebar } from '../contexts/SidebarContext.js'

const Header = () => {
  const { user } = useAuth()
  const { toggleSidebar } = useSidebar()

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 sticky top-0 z-30">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Toggle sidebar"
          >
            <Menu size={20} />
          </button>
          <div>
            <h2 className="text-xl font-semibold text-gray-900">
              Панель управління
            </h2>
            <p className="text-sm text-gray-500">
              Ласкаво просимо, {user?.fullName || 'Адміністратор'}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="text-right">
            <p className="text-sm font-medium text-gray-900">
              {user?.fullName || 'Адміністратор'}
            </p>
            <p className="text-xs text-gray-500">
              {user?.role === 'admin' ? 'Адміністратор' : 'Користувач'}
            </p>
          </div>
          <div className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center">
            <span className="text-white text-sm font-medium">
              {(user?.fullName || 'A').charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
